import { sectionLabels } from "../section-labels";
/**
 * The foot of the menu page: where the restaurant is, when it opens, how to
 * reach it.
 *
 * `locked` because this is the page's only answer to "can I actually go
 * there?". A menu with no address is a picture of food.
 *
 * Address and hours are FIELDS rather than reads off the store profile: a
 * restaurant's service hours are not its business hours, and a branch address
 * is not the company's registered one. Both were tried as inherited values and
 * both were wrong for the same reason — the storefront needs the door a diner
 * walks through, which nothing else in the store record holds.
 */
export const restaurantFooterSchema = {
    type: "restaurant-footer",
    name: sectionLabels["restaurant-footer"],
    description: {
        ar: "العنوان ومواعيد الفتح وطرق التواصل.",
        en: "Address, opening hours and how to get in touch.",
    },
    locked: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["home"],
    availableOnStoreKinds: ["RESTAURANT"],
    settings: [
        {
            id: "address",
            type: "textarea",
            i18n: true,
            label: { ar: "العنوان", en: "Address" },
            validate: { max: 200 },
        },
        {
            id: "hours",
            type: "textarea",
            i18n: true,
            label: { ar: "مواعيد الفتح", en: "Opening hours" },
            helpText: {
                ar: "سطر لكل يوم أو مجموعة أيام.",
                en: "One line per day, or per group of days.",
            },
            validate: { max: 240 },
        },
        {
            id: "phone",
            type: "text",
            label: { ar: "رقم التليفون", en: "Phone" },
            validate: { max: 32 },
        },
        {
            /**
             * The one-line footer the design draws: a wordmark line on one side and
             * a locations/hours line on the other. Distinct from `address` + `hours`,
             * which are the stacked multi-column treatment other skins use — a skin
             * takes whichever pair it is built around.
             */
            id: "legalLine",
            type: "text",
            i18n: true,
            label: { ar: "سطر الحقوق", en: "Copyright line" },
            validate: { max: 60 },
        },
        {
            id: "locationsLine",
            type: "text",
            i18n: true,
            label: { ar: "سطر الفروع والمواعيد", en: "Locations & hours line" },
            helpText: {
                ar: "الفروع والمواعيد في سطر واحد.",
                en: "Branches and opening hours, on one line.",
            },
            validate: { max: 90 },
        },
        {
            id: "mapUrl",
            type: "url",
            label: { ar: "لينك الخريطة", en: "Map link" },
            helpText: {
                ar: "لينك الموقع على الخرايط.",
                en: "A link to the place on a map.",
            },
        },
    ],
};
//# sourceMappingURL=restaurant-footer.js.map